<template>
    <div>
        <template v-for="(widget, widgetKey) in widgets">
            <!-- HTML more -->
            <div v-if="widget.type === 5 && isMoreWidget(widget.content[0]) && !fullContentShow" :key="widgetKey" class="moreButton">
                <a class="moreLink" @click="showFullText()">{{ $t('showInfo') }}</a>
            </div>
            <!-- HTML widget -->
            <div v-if="widget.type === 5" :key="widgetKey" class="more" v-html="filterStyle(widget.content[0])" />
            <!-- Product widget -->
            <div v-if="widget.type === 3" :key="widgetKey" class="more">
                <DelayHydration v-if="widget.showAsCarousel">
                    <CarouselBox
                        :products="widget.product || []"
                        class="carouselBox--fullWidth"
                        :item-list-name="itemListName"
                        :refresh-frequently-actualized-data="true"
                    />
                </DelayHydration>
                <div v-else class="row product-list-widget">
                    <div v-for="(product, productIndex) in widget.product" :key="productIndex" class="col-12 col-sm-6 col-md-3">
                        <ObjectsProduct
                            :item="product"
                            :is-carousel="false"
                            :item-list-name="itemListName"
                            :list-position="productIndex"
                            @product-redirected-to-url="(productUrl) => sendLuigisboxEvent(productUrl, LuigisBoxClickEventTypeEnum.Click)"
                            @product-added-to-basket="
                                (productUrl) => sendLuigisboxEvent(productUrl, LuigisBoxClickEventTypeEnum.Conversion)
                            "
                        />
                    </div>
                </div>
            </div>
            <!-- Navigation widget -->
            <div v-if="widget.type === 13 && widget.navigationItems && widget.navigationItems.length" :key="widgetKey" class="more">
                <h2 v-if="widget.navigationHeadline?.trim()" class="mt-5">{{ widget.navigationHeadline }}</h2>
                <ObjectsListSubCategories
                    :is-desktop="$device.isDesktop"
                    :sub-categories="resolveWidgetNavigationItems(widget)"
                    class="mb-4 mt-3"
                    :banners="[]"
                    :is-sale-and-discount-category="false"
                    :categories-to-show="9"
                />
            </div>
        </template>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { useNuxtApp } from '#app'
import CarouselBox from '~/components/elements/CarouselBox.vue'
import SlimCarousel from '~/mixins/SlimCarousel'
import Widget from '~/models/StaticContent/Widget'
import { LuigisBoxClickEventTypeEnum } from '~/models/LuigisBox/LuigisBoxClickEventTypeEnum'
import LuigisBoxEventApi from '~/extensions/LuigisBoxEventApi'
import CategoryTile from '~/models/Category/CategoryTile'

export default {
    components: {
        CarouselBox,
    },
    props: {
        widgets: {
            type: Array as PropType<Widget[]>,
            default: () => [],
        },
        itemListName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            fullContentShow: false,
        }
    },
    computed: {
        LuigisBoxClickEventTypeEnum() {
            return LuigisBoxClickEventTypeEnum
        },
    },
    mounted() {
        if (window) {
            const nuxtApp = useNuxtApp()
            const lazyload = nuxtApp.$lazyload
            const media = document.querySelectorAll('.lazyload')
            media.forEach((m) => lazyload(m as HTMLElement))
            //
            //     const mediaBg = document.querySelectorAll('[data-bg]')
            //
            //     mediaBg.forEach(media => {
            //         const BgImages = media.attributes.getNamedItem('data-bg').value
            //         const style = 'background-image: url("' + BgImages + '");'
            //         media.setAttribute('style', style)
            //     })
        }
    },
    methods: {
        isMoreWidget(widget: string): boolean {
            return widget.search('<!--more-->') !== -1
        },
        showFullText(): void {
            this.fullContentShow = true

            this.$nextTick(function () {
                const carousel = [...document.getElementsByClassName('slim-carousel')]
                carousel.forEach(function (item) {
                    new SlimCarousel({ el: item })
                })
            })
        },
        filterStyle(data: string): string {
            const regexStyle = /<link type="text\/css"[^>]+>/gi
            const regexLazy = /<script src=[^]+><\/script>/gi

            return data.replace(regexStyle, '').replace(regexLazy, '')
        },
        sendLuigisboxEvent(productUrl: string, type: LuigisBoxClickEventTypeEnum) {
            LuigisBoxEventApi.sendClickEvent(type, productUrl)
        },

        resolveWidgetNavigationItems(widget: Widget) {
            return widget.navigationItems as unknown as CategoryTile[]
        },
    },
}
</script>

<style lang="scss" scoped>
.moreButton ~ .more {
    display: none;
}

.moreButton {
    padding: 0.5rem;

    &:deep(.moreLink) {
        color: $color-cta;
        text-decoration: underline;
        font-size: 16px;
        cursor: pointer;

        &:hover {
            @media (min-width: 890px) {
                color: $color-cta;
                text-decoration: none;
            }
        }
    }
}

.product-list-widget {
    max-width: 960px;
    margin: 0 auto 50px;
}
</style>
